import { isInstitutionalActs, isInstitutionalRules } from '@urbanik/api-contracts';
export class InstitutionalRegisterApiError extends Error {
    status;
    constructor(status) {
        super(status === 403 ? 'No tienes permiso en esta entidad.' : 'No se pudo consultar el registro.');
        this.status = status;
    }
}
const valid = (id) => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(id);
async function request(base, org, path, signal) {
    if (!valid(org))
        throw new InstitutionalRegisterApiError(400);
    let response;
    try {
        response = await fetch(base.replace(/\/$/, '') +
            '/identity/multi-review/organizations/' +
            org +
            '/governance/' +
            path, { credentials: 'include', cache: 'no-store', signal: signal ?? null });
    }
    catch (error) {
        if (signal?.aborted)
            throw error;
        throw new InstitutionalRegisterApiError(503);
    }
    if (!response.ok)
        throw new InstitutionalRegisterApiError(response.status);
    return response;
}
async function json(response) {
    try {
        return await response.json();
    }
    catch {
        throw new InstitutionalRegisterApiError(502);
    }
}
export async function getInstitutionalActs(base, org, signal) {
    const data = await json(await request(base, org, 'acts', signal));
    if (!isInstitutionalActs(data, org))
        throw new InstitutionalRegisterApiError(502);
    return data;
}
export async function getInstitutionalRules(base, org, signal) {
    const data = await json(await request(base, org, 'rules', signal));
    if (!isInstitutionalRules(data, org))
        throw new InstitutionalRegisterApiError(502);
    return data;
}
export async function getInstitutionalRuleVersions(base, org, id, lineageId, signal) {
    if (!valid(id) || !valid(lineageId))
        throw new InstitutionalRegisterApiError(400);
    const data = await json(await request(base, org, 'rules/' + id + '/versions', signal));
    if (!isInstitutionalRules(data, org) ||
        !data.items.length ||
        !data.items.some((r) => r.id === id) ||
        data.items.some((r) => r.lineageId !== lineageId))
        throw new InstitutionalRegisterApiError(502);
    return data;
}
export async function getInstitutionalActDocument(base, org, id, signal) {
    if (!valid(id))
        throw new InstitutionalRegisterApiError(400);
    const response = await request(base, org, 'acts/' + id + '/document', signal);
    if (response.headers.get('x-urbanik-organization') !== org ||
        response.headers.get('content-type')?.split(';')[0] !== 'application/pdf')
        throw new InstitutionalRegisterApiError(502);
    return response.blob();
}
